"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reduxOidc = _interopRequireWildcard(require("redux-oidc"));
var _oidcClient = require("oidc-client");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SSOClient = /*#__PURE__*/function () {
  function SSOClient() {
    var _this = this;
    _classCallCheck(this, SSOClient);
    _defineProperty(this, "initializeMiddleware", function (ssoConfiguration) {
      _this._ssoConfiguration = ssoConfiguration;
      _this._userManager = (0, _reduxOidc.createUserManager)(_objectSpread(_objectSpread({}, ssoConfiguration), {}, {
        response_type: "id_token token",
        automaticSilentRenew: false,
        monitorSession: false,
        filterProtocolClaims: true,
        loadUserInfo: false,
        checkSessionInterval: 300000,
        userStore: new _oidcClient.WebStorageStateStore({
          store: new _oidcClient.InMemoryWebStorage()
        }),
        stateStore: new _oidcClient.WebStorageStateStore({
          store: window.sessionStorage
        })
      }));
      _this._ssoMiddleware = (0, _reduxOidc["default"])(_this._userManager);
    });
    this._userManager = null;
    this._ssoMiddleware = null;
    this._ssoConfiguration = null;
  }
  return _createClass(SSOClient, [{
    key: "userManager",
    get: function get() {
      return this._userManager;
    }
  }, {
    key: "ssoMiddleware",
    get: function get() {
      return this._ssoMiddleware;
    }
  }, {
    key: "ssoConfiguration",
    get: function get() {
      return this._ssoConfiguration;
    }
  }]);
}();
var _default = exports["default"] = SSOClient;